/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AssetClass3FromJSON(json) {
    return AssetClass3FromJSONTyped(json, false);
}
export function AssetClass3FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'assetClass3Id': !exists(json, 'assetClass3Id') ? undefined : json['assetClass3Id'],
        'assetClass3Name': !exists(json, 'assetClass3Name') ? undefined : json['assetClass3Name'],
        'assetClass2Name': !exists(json, 'assetClass2Name') ? undefined : json['assetClass2Name'],
        'attributeTemplateId': !exists(json, 'attributeTemplateId') ? undefined : json['attributeTemplateId'],
        '_function': !exists(json, 'function') ? undefined : json['function'],
        'physicalRisk': !exists(json, 'physicalRisk') ? undefined : json['physicalRisk'],
        'lifeSafetyFlag': !exists(json, 'lifeSafetyFlag') ? undefined : json['lifeSafetyFlag'],
    };
}
export function AssetClass3ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'assetClass3Id': value.assetClass3Id,
        'assetClass3Name': value.assetClass3Name,
        'assetClass2Name': value.assetClass2Name,
        'attributeTemplateId': value.attributeTemplateId,
        'function': value._function,
        'physicalRisk': value.physicalRisk,
        'lifeSafetyFlag': value.lifeSafetyFlag,
    };
}
